export default __webpack_public_path__ + "static/char-s-37-ko-951023500ff7818b35940ae8b1d87be7.webp";